<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划转移单{{ mode === 'add' ? '创建':'' }}</h3>
    <affix :error-list="errorList">
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="mode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY002', 'WLY004', 'WLYALL']) && !conditions.shift_id">
          <form-button type="primary" @click="saveData('SAVE')">保存</form-button>
          <form-button icon="form-advance" @click="saveData('SUBMIT')">提交</form-button>
        </template>
        <template v-if="conditions.shift_id">
          <template v-if="conditions.status === 'E002' && $_has(['WLY002', 'WLY004', 'WLYALL'])">
            <form-button v-if="!showEdit" @click="showEdit = true">修改</form-button>
          </template>
        </template>

        <template v-if="showEdit">
          <form-button @click="showEdit = false">显示</form-button>
          <template v-if="conditions.status === 'E002' && $_has(['WLY002', 'WLY004', 'WLYALL'])">
            <form-button icon="form-advance" @click="saveData('SUBMIT')">提交</form-button>
            <form-button @click="saveData('CANCEL')">取消</form-button>
          </template>
        </template>
      </div>
    </affix>

    <div class="form-container">
      <el-form
        ref="form"
        inline
        size="mini"
        :show-message="false"
        label-width="100px"
        :model="conditions"
        :rules="rules"
        :disabled="isEdit"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="year" label="转移单据号">
              <el-input v-model="conditions.shift_id" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer2" label="老客户">
              <wly-input
                v-model="conditions.customer1"
                input-type="customer"
                @enter="handleEnter(...arguments, 1)"
                @handleSuffixClick="showClient($event, 1)"
              />
              <!-- <el-input v-model="conditions.customer1_name" suffix-icon="el-icon-more" @focus="showClient($event, 1)" /> -->
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer1_name" label="老客户名称">
              <el-input
                :value="conditions.customer1_name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="year" label="单据类型">
              <el-input value="销售计划转移单" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer1" label="新客户">
              <wly-input
                v-model="conditions.customer2"
                input-type="customer"
                @enter="handleEnter(...arguments, 0)"
                @handleSuffixClick="showClient($event, 0)"
              />
              <!-- <el-input v-model="conditions.customer2_name" suffix-icon="el-icon-more" @focus="showClient($event, 0)" /> -->
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer2_name" label="新客户名称">
              <el-input
                :value="conditions.customer2_name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="gjahr" label="年度">
              <el-date-picker
                v-model="conditions.gjahr"
                value-format="yyyy"
                type="year"
                placeholder="选择年"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.create_name"
                placeholder="请输入"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="conditions.datum"
                placeholder="请输入"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-input v-model="conditions.status_text" clearable disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="clientDialog"
      :title="isOld ? '旧客户选择' : '新客户选择'"
      width="70%"
      destroy-on-close
    >
      <client-select ref="ClientSelect" />
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="clientDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="confirmClient"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import { getTranstionCreate, apiSalePlanTransformDetail } from '@/api/sap/sale-plan'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
export default {
  name: 'sale-plan-transfer',
  components: { ClientSelect },

  data() {
    const rules = {
      customer2: [{ required: true, message: '请选择新客户', trigger: 'change' }],
      customer1: [{ required: true, message: '请选择老客户', trigger: 'change' }],
      gjahr: [{ required: true, message: '请选择年度', trigger: 'change' }]
    }
    return {
      mode: 'add',
      rules,
      isOld: 0,
      showEdit: false,
      clientDialog: false,
      errorList: [],
      conditions: {
        gjahr: '',
        remark: '',
        customer1_name: '',
        customer1: '',
        customer2_name: '',
        customer2: '',
        status: 'E001',
        status_text: '新建',
        datum: '',
        uname: '',
        shift_id: ''
      },
      selectDataOptions: {}
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo']),
    isEdit() {
      if (this.conditions.shift_id) {
        return !this.showEdit
      } else {
        return false
      }
    }
  },
  created() {
    if (this.$route.query?.id) {
      this.mode = 'edit'
      this.getDetail()
    } else {
      this.mode = 'add'
      this.conditions.create_name = this.role.login_user
      this.conditions.uname = this.role.USER_BP
      this.conditions.datum = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
    }
  },

  methods: {
    async getDetail() {
      const iv_shift_id = this.$route.query.id
      const res = await apiSalePlanTransformDetail({ iv_shift_id })
      Object.assign(this.conditions, res.head)
      this.conditions.status = res.head.status
    },
    saveData(action) {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          const params = {
            iv_mode: action,
            user_bp: this.$store.getters.role.USER_BP,
            data: this.conditions
          }
          this.errorList = []
          const res = await getTranstionCreate(params)
          this.conditions.shift_id = res.info.shift_id
          if (res?.msg_type !== 'S') {
            this.errorList.push(res.message)
            return
          }
          this.showEdit = false
          this.$message.success(res.message)
          Object.assign(this.conditions, res.info)
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    showClient(e, type) {
      this.isOld = type
      this.clientDialog = true
      e.target.blur()
    },
    async confirmClient() {
      const data = await this.$refs.ClientSelect.submitForm()
      if (this.isOld) {
        this.conditions.customer1_name = data.customerName
        this.conditions.customer1 = data.customerCode
      } else {
        this.conditions.customer2_name = data.customerName
        this.conditions.customer2 = data.customerCode
      }
      this.clientDialog = false
    },
    // 控件回车
    async handleEnter(e, type, data, isOld) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      switch (type) {
        case 'customer':
          if (isOld) {
            this.conditions.customer1_name = data.customerName
            this.conditions.customer1 = data.customerCode
          } else {
            this.conditions.customer2_name = data.customerName
            this.conditions.customer2 = data.customerCode
          }
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  padding: 0 20px 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanTransfer.vue